document.addEventListener('click', async function (event) {
  const button = event.target.closest('.cart-upsell-btn');

  if (!button) return;

  event.preventDefault();

  if (button.disabled) return;

  const variantId = button.dataset.variantId;

  if (!variantId) {
    console.error('Cart Upsell: Missing variant ID.');
    return;
  }

  button.disabled = true;
  button.textContent = 'Adding...';

  try {
    /*
     * Detect where the upsell was clicked.
     */
    const cartDrawer = document.querySelector('cart-drawer');
    const isCartPage = window.location.pathname === '/cart';

    /*
     * ---------------------------------------------------------
     * FULL CART PAGE
     * ---------------------------------------------------------
     */
    /*
 * ---------------------------------------------------------
 * FULL CART PAGE
 * ---------------------------------------------------------
 */
if (isCartPage) {
  const mainCartItems = document.getElementById('main-cart-items');
  const mainCartFooter = document.getElementById('main-cart-footer');

  if (!mainCartItems || !mainCartFooter) {
    throw new Error('Cart page sections not found.');
  }

  /*
   * Use Shopify's REAL section IDs.
   * Refresh theme stores them in data-id.
   */
  const sections = [
    mainCartItems.dataset.id,
    mainCartFooter.dataset.id,
    'cart-icon-bubble',
    'cart-live-region-text'
  ];

  const response = await fetch(
    window.Shopify.routes.root + 'cart/add.js',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      })
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(
      data.description || 'Unable to add product.'
    );
  }

  /*
   * -------------------------------------------------------
   * UPDATE MAIN CART ITEMS
   * -------------------------------------------------------
   */
  if (data.sections && data.sections[mainCartItems.dataset.id]) {
    const parser = new DOMParser();

    const html = parser.parseFromString(
      data.sections[mainCartItems.dataset.id],
      'text/html'
    );

    const source = html.querySelector('.js-contents');
    const target = mainCartItems.querySelector('.js-contents');

    if (source && target) {
      target.innerHTML = source.innerHTML;
    }
  }

  /*
   * -------------------------------------------------------
   * UPDATE MAIN CART FOOTER
   *
   * IMPORTANT:
   * Your upsell is rendered here.
   * Replacing this section causes Liquid to run again
   * with the NEW cart contents.
   *
   * Therefore:
   * V-Wash is now in cart
   * → already_in_cart = true
   * → upsell disappears.
   * -------------------------------------------------------
   */
  if (data.sections && data.sections[mainCartFooter.dataset.id]) {
    const parser = new DOMParser();

    const html = parser.parseFromString(
      data.sections[mainCartFooter.dataset.id],
      'text/html'
    );

    const source = html.querySelector('.js-contents');
    const target = mainCartFooter.querySelector('.js-contents');

    if (source && target) {
      target.innerHTML = source.innerHTML;
    }
  }

  /*
   * -------------------------------------------------------
   * UPDATE CART ICON
   * -------------------------------------------------------
   */
  if (data.sections && data.sections['cart-icon-bubble']) {
    const parser = new DOMParser();

    const html = parser.parseFromString(
      data.sections['cart-icon-bubble'],
      'text/html'
    );

    const source = html.querySelector('.shopify-section');
    const target = document.getElementById('cart-icon-bubble');

    if (source && target) {
      target.innerHTML = source.innerHTML;
    }
  }

  /*
   * Refresh cart-related functionality.
   */
  document.dispatchEvent(
    new CustomEvent('cart:refresh')
  );

  return;
}

    /*
     * ---------------------------------------------------------
     * CART DRAWER
     * ---------------------------------------------------------
     */

    if (!cartDrawer) {
      throw new Error('Cart drawer not found.');
    }

    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          sections: [
            'cart-drawer',
            'cart-icon-bubble'
          ],
          sections_url: window.location.pathname
        })
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description || 'Unable to add product.'
      );
    }

    /*
     * Refresh drawer using Shopify's native
     * cart-drawer component.
     */
    if (
      typeof cartDrawer.renderContents === 'function'
    ) {
      cartDrawer.renderContents({
        id: variantId,
        sections: data.sections
      });
    }

  } catch (error) {
    console.error('Cart Upsell Error:', error);

    button.disabled = false;
    button.textContent = 'Add';
  }
});